export default __webpack_public_path__ + "static/media/senoark.b50ba22c.png";